import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement } from 'chart.js'
import maleIcon from '../assets/images/male.png'
import femaleIcon from '../assets/images/female.png'

ChartJS.register(ArcElement)

const GenderChart = ({ data }) => {
  const male = data.filter((d) => d.Gender?.trim().toLowerCase() === 'male').length
  const female = data.filter((d) => d.Gender?.trim().toLowerCase() === 'female').length
  const total = male + female

  const malePercent = ((male / total) * 100).toFixed(0)
  const femalePercent = ((female / total) * 100).toFixed(0)

  const createChartData = (value, color) => ({
    labels: ['Filled', 'Empty'],
    datasets: [
      {
        data: [value, 100 - value],
        backgroundColor: [color, '#e5e7eb'], // Tailwind gray-200
        borderWidth: 0,
        cutout: '80%',
      },
    ],
  })

  const options = {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    responsive: true,
    maintainAspectRatio: false,
  }

  return (
    <div className="bg-white rounded shadow p-4 w-full">
      <h2 className="font-semibold text-sm text-gray-700 mb-4">GENDER</h2>
      <div className="flex justify-center items-center space-x-8">
        {/* Male */}
        <div className="flex flex-col items-center">
          <div className="w-24 h-24 relative">
            <Doughnut data={createChartData(Number(malePercent), '#38bdf8')} options={options} />
            <div className="absolute inset-0 flex items-center justify-center">
              <img src={maleIcon} alt="Male" className="w-6 h-6" />
            </div>
          </div>
          <div className="mt-2 text-sm text-gray-700 font-medium">Male</div>
          <div className="text-xl font-bold text-gray-900">{malePercent}%</div>
        </div>

        {/* Female */}
        <div className="flex flex-col items-center">
          <div className="w-24 h-24 relative">
            <Doughnut data={createChartData(Number(femalePercent), '#f472b6')} options={options} />
            <div className="absolute inset-0 flex items-center justify-center">
              <img src={femaleIcon} alt="Female" className="w-6 h-6" />
            </div>
          </div>
          <div className="mt-2 text-sm text-gray-700 font-medium">Female</div>
          <div className="text-xl font-bold text-gray-900">{femalePercent}%</div>
        </div>
      </div>
    </div>
  )
}

export default GenderChart
